// Shared constants for the Modal

// Default styling values
export const DEFAULT_MODAL_WIDTH = "800px";
export const DEFAULT_MODAL_BG = "container.background.base";

// Max space allowed between the modal and the edge of the browser
// Note: 64px doesn't have a direct space token match (space[500] = 32px, space[600] = 40px)
// Keeping as hardcoded value for now as it's a specific layout constraint
export const BODY_PADDING = "64px";

// Size presets for simplified API
export const MODAL_SIZE_PRESETS = {
  small: "400px",
  medium: "600px",
  large: "800px",
  full: "90vw",
} as const;

// Rail button constants
export const RAIL_BUTTON_SIZE = 44; // px
export const RAIL_OFFSET = 12; // px from card edge
export const RAIL_GAP = 12; // px between buttons
export const RAIL_EXTRA_SPACE = RAIL_BUTTON_SIZE + RAIL_OFFSET; // 56px

// The rail hangs RAIL_EXTRA_SPACE off the card's right edge, so a strictly centered
// card leaves the card+rail group optically off-center by half of that. Modals shift
// left by this amount so the space left of the card matches the space right of the rail.
export const RAIL_CENTERING_OFFSET = RAIL_EXTRA_SPACE / 2; // 28px
